// extracted by mini-css-extract-plugin
export default {"pageContainer":"CreateResetSatForm_pageContainer__TP5OZ"};